var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.767029 4.83766C1.04869 5.44804 1.90817 5.90643 3.62713 6.8232C5.1793 7.65103 5.95539 8.06494 6.58884 7.98324C7.14171 7.91194 7.63973 7.61312 7.96282 7.15886C8.33301 6.63837 8.33301 5.75881 8.33301 3.99967C8.33301 2.24054 8.33301 1.36098 7.96282 0.840494C7.63973 0.386226 7.14171 0.0874127 6.58884 0.0161055C5.95539 -0.0655958 5.1793 0.348318 3.62713 1.17615C1.90817 2.09292 1.04869 2.55131 0.767029 3.16169C0.521668 3.69341 0.521668 4.30594 0.767029 4.83766Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayLeft);
export default __webpack_public_path__ + "static/media/play-left.3903404355341500fa866a405ba5a6ab.svg";
export { ForwardRef as ReactComponent };